import { CourierPickupSlot } from '../../../models/parcelDeliveryMiles';
import {
  formatCalendarDate,
  parseCalendarDate,
  toCalendarDateString,
} from '../../../utils/generic/generic.utils';

export const getDayOfWeek = (
  dateString: string,
  t: (key: string) => string
): string => {
  const date = parseCalendarDate(dateString);
  const dayOfWeek = date.getDay(); // 0 (Sun) to 6 (Sat)

  const translations = [
    'common_day_short_sun',
    'common_day_short_mon',
    'common_day_short_tue',
    'common_day_short_wed',
    'common_day_short_thu',
    'common_day_short_fri',
    'common_day_short_sat',
  ];

  return t(translations[dayOfWeek]);
};

export const formatDisplayDate = (
  dateString: string,
  t: (key: string) => string
): string => {
  const formattedDate = formatCalendarDate(dateString);
  const dayOfWeek = getDayOfWeek(dateString, t);
  return `${dayOfWeek} ${formattedDate}`;
};

export const formatDisplayTime = (from: string, to: string): string =>
  `${from} - ${to}`;

export const getNearestDate = (
  dateInfo: { date: string; time_slots: { from: string; to: string }[] }[],
  t: (key: string) => string
): {
  formattedDate: string;
  date: string;
  time_slots: { from: string; to: string }[];
} | null => {
  const today = new Date();
  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const nearestDate = dateInfo
    .map((parsed) => parseCalendarDate(parsed.date))
    .filter((date) => date >= todayStart)
    .sort((a, b) => a.getTime() - b.getTime())[0];

  if (!nearestDate) return null;

  const dateString = toCalendarDateString(nearestDate);
  const formattedDate = formatDisplayDate(dateString, t);
  const timeSlots =
    dateInfo.find((d) => d.date === dateString)?.time_slots || [];
  return { formattedDate, date: dateString, time_slots: timeSlots };
};

export function isCourierPickupEmpty(
  pickupInfo: CourierPickupSlot | undefined
) {
  return (
    !pickupInfo ||
    (!pickupInfo.date &&
      !pickupInfo.time_from &&
      !pickupInfo.time_to &&
      !pickupInfo.timezone)
  );
}
